{
  "title": "Subscription Management",
  "description": "Create and manage practitioner subscriptions",
  "practitioners": {
    "title": "Independent Practitioners",
    "createSubscription": "Create Subscription",
    "noPractitioners": "No independent practitioners found",
    "noProfile": "No profile",
    "extend": "Extend",
    "create": "Create",
    "table": {
      "name": "Name",
      "email": "Email",
      "subscription": "Subscription",
      "endDate": "End Date",
      "actions": "Actions"
    }
  },
  "status": {
    "noSubscription": "No Subscription",
    "active": "Active",
    "trial": "Trial",
    "expired": "Expired"
  },
  "create": {
    "title": "Create Practitioner Subscription",
    "description": "Create a subscription for an independent practitioner",
    "practitioner": "Practitioner",
    "selectPractitioner": "Select a practitioner",
    "subscriptionType": "Subscription Type",
    "trialType": "Pro Trial (15 days)",
    "proType": "Pro (Full access)",
    "startDate": "Start Date",
    "endDate": "End Date",
    "selectDate": "Select date",
    "existingSubscription": "This practitioner already has a {{type}} subscription ending on {{endDate}}. Creating a new subscription will replace the existing one.",
    "cancel": "Cancel",
    "confirm": "Create Subscription"
  },
  "update": {
    "title": "Update Subscription",
    "description": "Extend subscription for {{name}}",
    "currentType": "Current Type",
    "currentEndDate": "Current End Date",
    "newEndDate": "New End Date",
    "selectDate": "Select date",
    "cancel": "Cancel",
    "confirm": "Update Subscription"
  },
  "errors": {
    "createSubscriptionFailed": "Failed to create subscription",
    "updateSubscriptionFailed": "Failed to update subscription"
  },
  "success": {
    "createSubscriptionSuccess": "Subscription created successfully",
    "updateSubscriptionSuccess": "Subscription updated successfully"
  },
  "liberal": {
    "pageTitle": "My subscription",
    "pageSubtitle": "Manage your independent practitioner Pro plan",
    "trialActive": "Your free trial ends on {{date}}. Subscribe now to keep full access.",
    "trialExpired": "Your free trial has ended. Subscribe now to restore full access to the platform.",
    "monthly": {
      "title": "Monthly",
      "price": "€29.99",
      "period": "/month",
      "description": "Full access, no commitment",
      "cta": "Subscribe monthly"
    },
    "annual": {
      "title": "Annual",
      "price": "€299.99",
      "period": "/year",
      "savings": "2 months free",
      "description": "That is about €24.99/month",
      "cta": "Subscribe annually"
    },
    "active": {
      "title": "Active subscription",
      "nextBilling": "Next billing date",
      "manageButton": "Manage billing",
      "cancelButton": "Cancel subscription"
    },
    "canceled": {
      "title": "Cancellation scheduled",
      "description": "Your subscription will end on {{date}}. You keep access until that date."
    },
    "cancelDialog": {
      "title": "Cancel your subscription?",
      "description": "Your subscription will remain active until the end of the billed period. No refund will be issued.",
      "confirm": "Yes, cancel",
      "cancel": "No, keep it"
    },
    "errors": {
      "checkoutFailed": "Failed to create checkout session",
      "portalFailed": "Failed to open billing portal",
      "cancelFailed": "Failed to cancel subscription",
      "fetchFailed": "Failed to load your subscription"
    },
    "success": {
      "checkoutTitle": "Payment confirmed",
      "checkoutDescription": "Your Pro subscription is now active. Welcome!",
      "backToBilling": "Back to my subscription",
      "cancelSuccess": "Your subscription will be cancelled at the end of the current period"
    }
  }
}
